import React, { useEffect, useReducer, useState } from "react"
import { listarEntregadores } from "../../../services/entregadores"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { EntregadoresInicial } from "../models/entregadoresModel"
import { EntregadoresActionsTypes } from "./entregadoresActions"
import { EntregadoresContext } from "./EntregadoresContext"
import { entregadoresReducer } from "./entregadoresReducer"

export function EntregadoresContextProvider({ children }: { children: React.ReactNode }) {
    const [dados, dispatch] = useReducer(entregadoresReducer, EntregadoresInicial)
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)

    const carregar = async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await listarEntregadores(autorizacao)
            if ("retornoErro" in response) {
                setErroCarregamento(response.mensagem || "Erro ao carregar")
            } else {
                setErroCarregamento(null)
                dispatch({ type: EntregadoresActionsTypes.CARREGAR, payload: response })
            }
        } catch {
            setErroCarregamento("Erro ao carregar")
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        carregar()
    }, [])

    return (
        <EntregadoresContext.Provider value={{ dados, dispatch, erroCarregamento }}>
            <Loading />
            {children}
        </EntregadoresContext.Provider>
    )
}
